import proxyapi from './ProxyApi';

export async function getAverageProcessingTime(promptType) {
  try {
    const { data } = await proxyapi.get(`/api/v1/processing-times/average/${promptType}`);
    return data;
  } catch (error) {
    console.error(`Error fetching average processing time for ${promptType}:`, error);
    return {
      status: 'error',
      hasEnoughData: false,
      averageSeconds: null,
      recordCount: 0
    };
  }
}